'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardSystemSiteStats(host, total) {
  this.DW = null;
  this.DX = 0;
  this.DW = host;
  this.DX = total;
}
export { $c_Lpresto_types$DashboardSystemSiteStats as $c_Lpresto_types$DashboardSystemSiteStats };
$p = $c_Lpresto_types$DashboardSystemSiteStats.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardSystemSiteStats;
/** @constructor */
function $h_Lpresto_types$DashboardSystemSiteStats() {
}
export { $h_Lpresto_types$DashboardSystemSiteStats as $h_Lpresto_types$DashboardSystemSiteStats };
$h_Lpresto_types$DashboardSystemSiteStats.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("DashboardSystemSiteStats"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.DW));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.DX);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 2);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$DashboardSystemSiteStats) && ((this.DX === x$0.DX) && (this.DW === x$0.DW))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "DashboardSystemSiteStats";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.DW;
  }
  if ((n === 1)) {
    return this.DX;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$DashboardSystemSiteStats(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jL)));
}
export { $isArrayOf_Lpresto_types$DashboardSystemSiteStats as $isArrayOf_Lpresto_types$DashboardSystemSiteStats };
var $d_Lpresto_types$DashboardSystemSiteStats = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardSystemSiteStats, "presto.types$DashboardSystemSiteStats", ({
  jL: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$DashboardSystemSiteStats as $d_Lpresto_types$DashboardSystemSiteStats };
//# sourceMappingURL=presto.types$-Dashboard-System-Site-Stats.js.map
